import { createRouter, createWebHistory } from 'vue-router'
import { sessionUserStore } from '../store/session-store/session'
import { permissionsUserStore } from '../store/permissions-store/permissions'
import { userInformationRoutes } from '../routes/userInformationRoutes'
import { userAccessRoutes } from '../routes/userAccessRoutes'
import { satVaultRoutes } from '../routes/satVaultRoutes'
import { payrollRoutes } from '../routes/payroallRoutes'
import { paymentRoutes } from '../routes/paymentRoutes'
import { manualLoadRoutes } from '../routes/manualLoadRoutes'
import { errorRoutes } from '../routes/errorRoutes'
import { emittedReceivedRoutes } from '../routes/emittedReceivedRoutes'
import { dashboardRoutes } from '../routes/dashboardRoutes'
import { chatgptRoutes } from '../routes/chatgptRoutes'
import { blackListRoutes } from '../routes/blackListRoutes'
import { billingRoutes } from '../routes/billingRoutes'
import { analyticsRoutes } from '../routes/analyticsRoutes'
import {sanferRoutes} from "../routes/sanferRoutes";

const routes = [
  ...errorRoutes,
  ...userInformationRoutes,
  ...userAccessRoutes,
  ...satVaultRoutes,
  ...payrollRoutes,
  ...paymentRoutes,
  ...manualLoadRoutes,
  ...emittedReceivedRoutes,
  ...dashboardRoutes,
  ...chatgptRoutes,
  ...blackListRoutes,
  ...analyticsRoutes,
  ...billingRoutes,
  ...sanferRoutes
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const storeSession = sessionUserStore()
  const permissionsStore = permissionsUserStore()

  if (to.matched.some(record => record.meta.requiresAuth) && !storeSession.getIsLoggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // if (to.matched.some(record => record.meta.requiresLogout) && storeSession.getIsLoggedIn) {
  //   next({ path: '/' })
  //   return
  // }

  if (to.matched.some(record => record.meta.requiresAdmin) && !permissionsStore.getIsAdmin) {
    next({ path: '/' })
    return
  }

  // Las rutas de módulo declaran el catálogo completo de permisos en el padre,
  // mientras que cada ruta hija declara el permiso concreto de la opción.
  // Validar todos los registros hacía que un usuario con un subconjunto de
  // permisos (por ejemplo, Esencial) no pudiera entrar a ninguna opción.
  const routeWithPermissions = [...to.matched]
    .reverse()
    .find(record => record.meta.permissions)
  const routePermissions = new Set(routeWithPermissions?.meta.permissions || [])


  if (routePermissions.size > 0) {
    const userPermissions = permissionsStore.permissions || []
    const hasPermission = [...routePermissions].every(routePerm => userPermissions.includes(routePerm))
    if (!hasPermission) {
      next({ path: '/' })
      return
    }
  }

  next()
})

const noDisplayRoutes = new Set([
  '/login',
  '/reset-password',
  '/set-password',
  '/set-password/',
  '/signup',
  '/checkout-session/success',
  '/validate-email',
  '/new-payment',
  '/payment-business',
  '/collection-login',
  '/collection-signup',
  '/404',
  '/403',
  '/500',
  '/validateInformation',
  '/signup-pymes'
])

export {
  router,
  noDisplayRoutes
}
